const content = (
  <div>
    <p>
      Pour impulser une culture d'entreprise innovante, il est vital de
      promouvoir un état d'esprit flexible et constructif. Vous devrez apprendre
      à mesurer le potentiel innovateur de votre équipe, explorer les outils et
      méthodes essentiels pour booster la créativité, et mettre en place un plan
      d'actions adapté à votre groupe.
    </p>

    <h2>Public Concerné</h2>
    <p>
      Cette formation s'adresse aux managers d'équipes et à tous ceux qui
      souhaitent impulser la créativité en passant par l’innovation de leurs
      équipes.
    </p>
    <h2>Prérequis</h2>
    <p>Des connaissances en management sont un vrai plus. </p>
    <h2>Objectifs Pédagogiques</h2>
    <p>À la fin de cette formation, le participant saura :</p>
    <ul>
      <li>
        Encourager une culture organisationnelle orientée vers l'innovation
      </li>
      <li>
        Effectuer une évaluation approfondie de son équipe ou de l'ensemble de
        l'entreprise
      </li>
      <li>Renforcer la capacité de créativité au sein de son équipe</li>
      <li>
        Utiliser des méthodes et outils stratégiques pour augmenter la
        créativité
      </li>
      <li>
        Déterminer le niveau d'innovation à travers des indicateurs définis
      </li>
    </ul>

    <p>Dates : Définies selon planning</p>
    <p>
      Durée : 2 jours de 9 h00 à 17h, soit 7 heures effectives de formation par
      jour
    </p>
    <p>
      Durée : A distance, avec ou sans regroupements, en partie à distance et en
      partie en présentiel
    </p>
    <p>
      Organisation : A distance, avec ou sans regroupements, en partie à
      distance et en partie en présentiel
    </p>
    <p>En intra ou inter entreprise</p>
    <p>Taille du groupe : jusqu’à 10 stagiaires</p>
    <p>Lieux</p>
    <p>En intra : Chez le client</p>
    <p>En inter : Des salles de formation sont proposées à Paris</p>

    <h2>Accessibilité</h2>
    <p>
      Pour toute situation de handicap merci de nous contacter pour envisager la
      faisabilité
    </p>

    <h2>Délai et modalités d'accès</h2>
    <p>
      Jusqu'à 48h avant le début de la formation et en fonction des plannings
    </p>
    <h2>Tarifs</h2>
    <p>1.200 Euros hors taxes pour les 2 jours de formation par stagiaire</p>

    <h2>1/ Comprendre les défis liés à l'innovation </h2>

    <p>Distinguer entre innovation et créativité.</p>
    <p>
      Reconnaître les avantages de l'innovation et les obstacles qui peuvent
      l'entraver.
    </p>
    <p>Considérer la créativité comme une approche moderne de gestion.</p>
    <h3>Exercices pratiques :</h3>
    <p>
      Jeux de rôles pour créer un climat de confiance et fournir des retours
      individualisés.
    </p>
    <h2>2/ Effectuer un diagnostic complet</h2>
    <p>Conduire un audit approfondi de l’équipe ou de l'entreprise.</p>
    <p>
      Examiner les pratiques des organisations les plus créatrices et
      innovantes.
    </p>
    <p>Comprendre le potentiel créatif.</p>
    <h3>Exercices pratiques :</h3>
    <p>
      Auto-évaluation de son potentiel créatif et de celui de ses collaborateurs
      /Analyse et restitution personnalisée.
    </p>
    <h2>3/ Implémenter un processus d'innovation</h2>
    <p>
      Sélectionner une stratégie qui convient tant à l'entreprise qu'à l'équipe.
    </p>
    <p>
      Gérer les défis liés à l'espace et au temps, et valoriser l'innovation en
      tant que compétence clé.
    </p>
    <p>
      Encourager systématiquement la génération d'idées et optimiser
      l'intelligence créative de l'équipe.
    </p>
    <p>Renforcer l’esprit d'équipe à travers des jeux créatifs.</p>

    <h3>Exercices pratiques :</h3>
    <p>
      Exercices pour renforcer l'ouverture d'esprit et la cohésion d'équipe via
      des jeux de confiance créative.
    </p>
    <h2>4/ Encourager la créativité au quotidien</h2>
    <p>Appliquer des méthodes pour maintenir un environnement innovant.</p>
    <p>
      Nourrir des relations basées sur la confiance, qui favorisent la
      créativité.
    </p>
    <p>
      Maîtriser l'art de poser des questions qui stimulent la réflexion et
      encouragent une dynamique de groupe positive.
    </p>
    <p>Pratiquer l'art du questionnement constructif.</p>

    <h3>Exercices pratiques :</h3>
    <p>QCM et feedback</p>

    <h2>5/ Développer le potentiel créatif</h2>
    <p>
      Explorer divers outils et méthodes, et comprendre leurs avantages et
      limites.
    </p>

    <p>
      S'entraîner à la pensée divergente, au brainwriting, et à l'usage de
      techniques telles que les six chapeaux de Bono et le rolestorming.
    </p>
    <p>
      Appliquer la pensée intuitive, les techniques de recadrage et les
      approches métaphoriques.
    </p>
    <h3>Exercices pratiques :</h3>
    <p>
      Mettre en œuvre ces outils à travers des exercices pratiques en groupe{" "}
    </p>

    <h2>6/ Formaliser une approche d'innovation </h2>
    <p>Analyser les objectifs et reformuler les problématiques.</p>
    <p>Générer et distinguer les idées de valeur.</p>
    <p>
      Adopter un cycle de gestion des idées incluant leur génération,
      protection, et recyclage.
    </p>
    <p>
      Évaluer et sélectionner les meilleures solutions, et les mettre en œuvre
      efficacement.
    </p>
    <h3>Exercices pratiques :</h3>
    <p>Création d’une matrice d’innovation </p>

    <h2>7/ Évaluer l'innovation</h2>
    <p>Les indicateurs qualitatifs et quantitatifs.</p>
    <p>Les indicateurs pour la cohésion d'équipe.</p>
    <p>Les indicateurs pour la motivation.</p>
    <p>Les indicateurs pour la fidélisation des talents.</p>
    <h3>Exercices pratiques :</h3>
    <p>Echanges et réflexion</p>

    <h2>Modalités pratiques</h2>
    <h3>Travaux pratiques</h3>
    <p>Mise en situation, auto prospection/diagnostic, et cas pratiques </p>

    <h3>Méthodes pédagogiques </h3>
    <p>
      Pédagogie active basée sur des échanges, une évaluation tout au long de la
      formation et de nombreux exercices de mise en application.
    </p>

    <h2>Modalités d'évaluation</h2>
    <p>
      Tout au long de la session de formation, le formateur suit l'avancement
      pédagogique du participant grâce à divers outils tels que des
      questionnaires à choix multiples, des simulations pratiques et d'autres
      exercices appliqués. De plus, le participant réalise un test de
      positionnement avant et après la formation afin de confirmer les
      compétences développées.
    </p>
  </div>
);

export default content;
